module.exports = __webpack_public_path__ + "static/media/bogdanka_dapic.20aedc41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/bogdanka_dapic.jpg
// module id = 429
// module chunks = 0